var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVuetifyjs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 293,
    viewBox: "0 0 256 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 0H68L128 141.816",
    fill: "#1697F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 0H188L128 141.816",
    fill: "#1867C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128 182.744V292.46L0 42.5576H67.049",
    fill: "#7BC6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128 182.746V292.461L256 42.5596H188.951",
    fill: "#AEDDFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuetifyjs);
export default __webpack_public_path__ + "static/media/vuetifyjs.8a22a3ec81ad62e97094feab6e7ee0fb.svg";
export { ForwardRef as ReactComponent };